import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/hd2/Documents/lav/Iron+/sito/nextjs/iron-static-2/src/app/components/homepage.js");
